<template>
  <a-layout-sider class="sider">
    <a-menu v-model:selectedKeys="selectedKeys" mode="inline" class="menu">
      <a-menu-item v-for="item in menuItems" :key="item.key" style="text-align: left;">
        <component :is="item.icon" /> {{ item.label }}
      </a-menu-item>
    </a-menu>
  </a-layout-sider>
  <a-layout class="content-scroll">
    <component :is="menuItems.find(item => item.key === selectedKeys[0]).component" />
  </a-layout>
</template>

<script setup>
import { ref } from 'vue';
import { TeamOutlined, PullRequestOutlined, ExclamationCircleOutlined, RiseOutlined } from '@ant-design/icons-vue';

import CommitterAnalysis from './CommitterAnalyis.vue';
import SigPr from './SigPr.vue';
import SigIssue from './SigIssue.vue';
import CommitterStat from './CommitterStat.vue';

const selectedKeys = ref(['1']);

const menuItems = [
  { key: '1', icon: TeamOutlined, label: 'Committer 分析', component: CommitterAnalysis },
  { key: '2', icon: RiseOutlined, label: 'Committer 贡献看板', component: CommitterStat },
  { key: '3', icon: PullRequestOutlined, label: 'SIG PR 分析', component: SigPr },
  { key: '4', icon: ExclamationCircleOutlined, label: 'SIG Issue 分析', component: SigIssue },
];
</script>

<style scoped>
.sider {
  box-shadow: 2px 0 8px #f0f1f2;
}

.menu {
  height: 100%;
}

.content-scroll {
  padding: 0 24px 24px;
  overflow-y: scroll;
  flex: 1;
  background: #F9FAFB;
}

.coming-soon {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #2b67a8;
}
</style>
